function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fontWeight: 400,
    fontFamily: "sans-serif",
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.15137 0 0 .09868 -29.139 -48.069)",
    style: {
      lineHeight: "125%"
    },
    x: 157.872,
    y: 738.685,
    fontSize: 366.208,
    fill: "#3e3e48"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 157.872,
    y: 738.685,
    style: {
      InkscapeFontSpecification: "'Nunito Sans'"
    },
    fontSize: 340.599,
    fontFamily: "Nunito Sans"
  }, "[")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: "100%"
    },
    x: 326.78,
    y: 573.486,
    fontSize: 246.245,
    fill: "#94a8b1",
    transform: "matrix(.12222 0 0 .12222 -29.139 -48.069)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 326.78,
    y: 573.486,
    style: {
      lineHeight: "100%",
      InkscapeFontSpecification: "'Nunito Sans, Normal'",
      textAlign: "start"
    },
    fontSize: 191.667,
    fontFamily: "Nunito Sans"
  }, "jz")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-.15137 0 0 -.09868 -29.139 -48.069)",
    style: {
      lineHeight: "125%"
    },
    x: -465.515,
    y: -559.871,
    fontSize: 366.208,
    fill: "#3e3e48"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -465.515,
    y: -559.871,
    style: {
      InkscapeFontSpecification: "'Nunito Sans'"
    },
    fontSize: 340.599,
    fontFamily: "Nunito Sans"
  }, "["))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55d20123d894ed0c7fdc02c02b155b13.svg";
export { ForwardRef as ReactComponent };